import store from '@/state/store'
import guestMiddleware from './../middleware/guestMiddleware';

export default [

  //#region Standard Dashboard Routes.
  //#region Auth Routes.
  {
    path: '/',
    name: 'default',
    redirect: store.getters['auth/loggedIn'] ? '/statistics' : '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    beforeEnter: guestMiddleware
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/account/account')
  },
  //#endregion
  
  //#region Errors Routes.
  {
    path: '*',
    redirect: '/404',
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '/500',
    name: '500',
    component: require('./views/utility/500').default,
  },
  //#endregion
  
  //#region Admin Routes.
  {
    path: '/statistics',
    name: 'statistics',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/statistics/index')
  },
  {
    path: '/admins',
    name: 'admins.index',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_admin|add_admin|edit_admin|delete_admin'],
    },
    component: () => import('./views/admins/index')
  },
  {
    path: '/admins/:id/edit',
    name: 'admins.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_admin'],
    },
    component: () => import('./views/admins/edit')
  },
  {
    path: '/admins/password/:id/reset',
    name: 'admins.password.reset',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/admins/reset_password')
  },
  {
    path: '/admins/log_activity',
    name: 'admins log_activity',
    meta: {
        middleware: ['authMiddleware', 'canMiddleware:show_logs'],
    },
    component: () => import('./views/admins/log_activity')
  },
  //#endregion

  //#region Custom Dashboard Routes.

  //#region application api Routes.
  {
    path: '/application',
    name: 'application',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_volunteer_application|show_details_volunteer_application'],
    },
    component: () => import('./views/application/index')
  },
  {
    path: '/application/:id',
    name: 'application.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_volunteer_application'],
    },
    component: () => import('./views/application/details')
  },
  //#endregion

  //#region activities api Routes.
  {
    path: '/activities',
    name: 'activities',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_volunteer_activities|show_details_volunteer_activities'],
    },
    component: () => import('./views/activities/index')
  },
  {
    path: '/activities/:id',
    name: 'activities.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_volunteer_activities'],
    },
    component: () => import('./views/activities/details')
  },
  //#endregion

  //#region work team api Routes.
  {
    path: '/workTeam',
    name: 'workTeam',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_volunteer_work_team|show_details_volunteer_work_team'],
    },
    component: () => import('./views/work_team/index')
  },
  {
    path: '/workTeam/:id',
    name: 'workTeam.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_volunteer_work_team'],
    },
    component: () => import('./views/work_team/details')
  },
  //#endregion

  //#region export Data api Routes.
  {
    path: '/exportData',
    name: 'exportData',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:export_to_excel_volunteer_application|export_to_excel_volunteer_activities|export_to_excel_volunteer_work_team'],
    },
    component: () => import('./views/export_data/index')
  },
  //#endregion

  //#endregion
]
